import React from "react";
import PropTypes from "prop-types";
import { isBreakpoint } from "../utility/WindowSizeHooks"
import PublicCatalogLayout from "../layouts/PublicCatalogLayout"
import { formatEventDate } from "../utility/DateUtils"
import EventModal from "./EventModal"
import EventCloneModal from "./modals/EventCloneModal"
import moment from 'moment'
import Cookies from "universal-cookie";
import { isHoldPacked } from "../utility/HoldUtils"
import { isJaguar, isSuperadmin, isClient } from "../utility/UserUtils"
import Select from 'react-select'
import { TextField } from "@mui/material"

class EventsDashboard extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      events: props.events || [],
      sortBy: "start_date",
      showArchived: false,
      search: ""
    }

    this.setSortBy = this.setSortBy.bind(this);
    this.updateEvent = this.updateEvent.bind(this);
    this.addEvent = this.addEvent.bind(this);
    this.toggleArchivedEvents = this.toggleArchivedEvents.bind(this);
    this.deleteEvent = this.deleteEvent.bind(this);
  }


  renderActions(event) {
    const { user } = this.props;
      return (
        <React.Fragment>
          <td className="action">
            <div className="actions-div gap-4">
              <div className="actions-column gap-4 flex-1 flex flex-col ">
                <EventModal
                  button={(
                    <button className="bg-[var(--primary-color)] h-4 w-full flex-col action-button">
                      Edit
                    </button>
                  )}
                  renters={this.props.renters}
                  updateEvent={this.updateEvent}
                  event={event}
                  shipping_addresses={this.props.shipping_addresses}
                />
                <EventCloneModal
                  button={(
                    <button className="bg-[var(--secondary-color)] h-4 w-full flex-col action-button">
                      Clone
                    </button>
                  )}
                  event={event}
                  shipping_addresses={this.props.shipping_addresses}
                />
          
                
              </div>
              <div className="actions-column gap-4 flex-1 flex flex-col ">
                <button className="bg-[var(--cancel-color)] h-4 w-full action-button"
                  onClick={() => this.archiveEvent(event)}
                >
                  {event.archived_at ? "Unarchive" : "Archive" }
                </button>
                <button onClick={() => this.deleteEvent(event)} className="bg-[var(--danger-color)] h-4 w-full action-button">
                  Delete
                </button>
              </div>
            
            {/* <EventModal
                
                button={(
                  <a href="#" className="action-button">Edit Event</a>
                  )}
                renters={this.props.renters}
                updateEvent={this.updateEvent}
                event={event}
                shipping_addresses={this.props.shipping_addresses}
              />
              <EventCloneModal
                button={(
                  <a href="#" className="action-button">Clone Event</a>
                )}
                event={event}
                shipping_addresses={this.props.shipping_addresses}
              />
              <a className="action-button"onClick={() => this.archiveEvent(event)} href="#">
                {event.archived_at ? "Unarchive" : "Archive" }
              </a>

              <a oclassName="action-button" nClick={() => this.deleteEvent(event)} href="#">
                Delete
              </a> */}
            </div>
          </td>
        </React.Fragment>
      )
  }


  sortedEvents() {
    const { events, sortBy, search } = this.state;
    const { archive } = this.props;
    const sortedEvents = events.sort((a,b) => {
      if(sortBy == "name"){
        const sortA = a["name"];
        const sortB = b["name"];
        if(sortA < sortB) { return -1; }
        if(sortA > sortB) { return 1; }
        return 0;
      }
      else {
        const sortA = moment(a[sortBy]);
        const sortB = moment(b[sortBy]);

        return sortBy == "created_at" || (sortBy == "start_date" && archive) ?  (sortB - sortA) : (sortA - sortB);
      }
    });

    const filteredEvents =  sortedEvents.filter(event => {
      if(search) {
        return (event.name||"").toLowerCase().includes(search.toLowerCase()) || (
          (event.job_number||"").toLowerCase().includes(search.toLowerCase())
        )
      }else {
        return true
      }
    })

    return filteredEvents
  }

  setSortBy(sortBy) {
    this.setState({
      sortBy
    });
  }

  getActiveSortByClass(sort) {
    const { sortBy } = this.state;
    if(sort == sortBy) {
      return "active"
    }
  }

  addEvent(event){
    this.setState({
      events: this.state.events.concat([event])
    })
  }

  updateEvent(event){
    this.setState({
      events: this.state.events.filter(event2 => event2.id != event.id).concat([event])
    });
  }

  renderEventRow(event) {
    return (
      <React.Fragment>
        <tr key={`event-${event.id}`}>
          <td className="event-name">
            <a href={`/events/${event.slug}`}>{event.name}</a>
            {isJaguar(this.props.user) ? (
              <div className="event-job-number">
                {event.job_number}
              </div>
            ):""}
         
          </td>
          <td className="date">{formatEventDate(event)}</td>
          <td className="reserved"> {Math.max(event.total_item_count, 0)} </td>
          <td className="packed"> {event.total_packed_count} </td>
          <td className="shipped"> {event.total_shipped_count} </td>
          {this.renderActions(event)}
        </tr>
      </React.Fragment>
    )
  }

  archiveEvent(event) {
    const cookies = new Cookies();
    const token = cookies.get("X-CSRF-Token");

    fetch(`/events/${event.slug}/archive`, {
      method: 'POST',
      redirect: "manual",
      body: JSON.stringify({archive: !event.archived_at}),
      headers: {
        "X-CSRF-Token": token,
        "Content-Type": 'application/json'
      }
    })
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (json.error == null) {
          this.setState({
            events: this.state.events.filter(event2 => json.event.id != event2.id)
          })
        } else {
          alert(json.error);
        }
      });
  }

  deleteEvent(event) {
    const cookies = new Cookies();
    const token = cookies.get("X-CSRF-Token");
    if(confirm("Are you sure you want to delete this event? This cannot be undone.")){
      fetch(`/events/${event.slug}`, {
        method: 'DELETE',
        redirect: "manual",
        headers: {
          "X-CSRF-Token": token,
        }
      })
        .then(response => {
          return response.json();
        })
        .then(json => {
          if (json.error == null) {
            this.setState({
              events: this.state.events.filter(event2 => event.id != event2.id)
            })
          } else {
            alert(json.error);
          }
        });
    }
  }

  renderEventsTable(events) {
    const rows = events.map( event => (
      this.renderEventRow(event)
    ));
    return (
      <table className="events-dashboard-table">
        <thead>
          <tr>
            <th className="event-name-header">Name</th>
            <th className="event-date-header">Event Date</th>
            <th className="small-header">Reserved</th>
            <th className="small-header">Packed</th>
            <th className="small-header">Shipped</th>
            <th className="action">Actions</th>
          </tr>
        </thead>
        <tbody>
          {rows}
        </tbody>
      </table>
    )
  }

  toggleArchivedEvents() {
    this.setState({
      showArchived: !this.state.showArchived
    })
  }

  renderArchivedEvents() {
    const { showArchived } = this.state;
    const table = showArchived ? this.renderEventsTable(this.sortedEvents().filter(e=> e.archived_at)) : "";
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-xs-12 archive-events-header" onClick={this.toggleArchivedEvents}>
            Archive&nbsp;&nbsp;
            {showArchived ?
              (<i class="fas fa-sort-down" />)
              :
              (<i class="fas fa-sort-down archive-arrow-rotated" />)
            }
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            {table}
          </div>
        </div>
      </React.Fragment>
    )
  }


  renderSortBy() {

    const sortByOptions = [
      { value: "name", label: "Name" },
      { value: "start_date", label: "Event Date" },
      { value: "created_at", label: "Recently Added" },
    ];
    const { sortBy } = this.state;
    return (
      <>
        <div className="float-right col-xs-12 col-md-2">
          <Select 
            className="select-outlined"
            classNamePrefix="select-outlined"
            options={sortByOptions}
            value={sortByOptions.find(option => option.value === sortBy)||{}}
            onChange={(e) =>this.setState({sortBy: e.value})}
            placeholder="Sort By"
            label="Sort By"
          />
        </div>
        <div className="float-right col-xs-12 col-md-2">
          <TextField
            label="Search Events"
            value={this.state.search}
            onChange={(e) => this.setState({search: e.target.value})}
            size="medium"
            sx={{
              "& .MuiInputBase-root": {
                height: 38, // Sets the total height of the input container
              },
              //Fix placeholder vertical center
              '& .MuiFormLabel-root': {
                margin: "-5px"
              },
            }}
          />
        </div>
      </>
    );
  }

  render() {
    const { children, user, archive} = this.props;
    return (
      <PublicCatalogLayout 
        currentPage="events" {...this.props}
        className="events-dashboard"
        classNames={{container: 'full-width-container'}}
      >
        <div className="events-dashboard">
          <div className="row">
            <div className="col-xs-12">
              <h1 class="catalog-h1">{archive ? "Archived Events" : "Events"}</h1>
            </div>
            {isJaguar(user) ? (
              <div className="col-xs-12 col-sm-6">
                {archive ? "" : (
                  <EventModal
                    buttonClasses="inline-block"
                    button={(
                      <button className="btn-outlined">
                        Add Event
                      </button>
                      )}
                    renters={this.props.renters}
                    addEvent={this.addEvent}
                    shipping_addresses={this.props.shipping_addresses}
                  />
                )}

                {archive ? (
                  <a href="/events">
                    <button className="btn-outlined ml-2">
                      View Events
                    </button>
                  </a>
                ):(
                  <a href="/events/archive">
                    <button className="btn-outlined ml-2">
                      View Archives
                    </button>
                  </a>
                )}
              </div>
            ):""}
            {this.renderSortBy()}
          </div>
          <br />
          <br />
          {this.renderEventsTable(this.sortedEvents())}
        </div>
      </PublicCatalogLayout>
    );
  }
}

EventsDashboard.propTypes = {

};

export default EventsDashboard;
